import type { TrackedTranslation } from '@ps/web-shared-components';
import { Translation } from '@ps/web-shared-components';
import { createForm } from '@ps/web-shared-ui';
import React from 'react';
import { useSelector } from 'react-redux';
import { lastValueFrom } from 'rxjs';

import Toggle from '@swf/components/Inputs/Toggle';
import Button from '@swf/components/StarsButton/StarsButton';
import { select } from '@swf/core/store';
import type { Article } from '@swf/help';

import {
  TXTCLI_Submit,
  TXTWCL_ItXs_taking_too_long_to_find_t_ELL,
  TXTWCL_Please_tell_us_more_about_what_ELL,
  TXTWCL_The_image_link_video_is_broken,
  TXTWCL_The_information_is_unclear_or__ELL,
  TXTWCL_The_topic_is_correct_but_the_i_ELL,
  TXTWCL_WeXre_sorry_to_hear_thatX__2
} from './NegativeFeedback.messages.json';
import styles from './NegativeFeedback.scss';
import useSendRequest from './hooks';
import { FeedbackType } from './types';
import type { FeedbackAnswerKey, FeedbackStates } from './types';

interface Props {
  article: Article;
  setSubmitted(submitted: FeedbackStates): void;
}
interface FormValues {
  answerKey: FeedbackAnswerKey;
}

const FeedbackQuestionItems: {
  [key in FeedbackAnswerKey]: TrackedTranslation;
} = {
  UNCLEAR_INFO: TXTWCL_The_information_is_unclear_or__ELL,
  BROKEN_DATA: TXTWCL_The_image_link_video_is_broken,
  DID_NOT_HELP: TXTWCL_The_topic_is_correct_but_the_i_ELL,
  LONG_SEARCH_TIME: TXTWCL_ItXs_taking_too_long_to_find_t_ELL
};

const Form = createForm<FormValues>();

const NegativeFeedback: React.FC<Props> = ({ article = {} as Article, setSubmitted }) => {
  const locale = useSelector(select.locale.get);
  const { handleSubmit } = useSendRequest();

  const handleNegativeFeedback = ({ answerKey }: FormValues) => {
    lastValueFrom(
      handleSubmit({
        type: FeedbackType.No,
        answerKey,
        locale,
        article,
        url: window.location.href
      })
    )
      .then(() => setSubmitted(FeedbackType.No))
      .catch(() => setSubmitted(''));
  };
  return (
    <Form
      onSubmit={handleNegativeFeedback}
      initialValues={{ answerKey: undefined }}
      render={({ pristine }) => (
        <>
          <p className={styles.furtherHelpText}>
            😩&nbsp;
            <Translation {...TXTWCL_WeXre_sorry_to_hear_thatX__2} />
            <Translation {...TXTWCL_Please_tell_us_more_about_what_ELL} />
          </p>
          <div className={styles.feedbackRadioGroup}>
            {Object.entries(FeedbackQuestionItems).map(([answerKey, translation]) => (
              <Toggle
                key={answerKey}
                id={answerKey}
                name="answerKey"
                value={answerKey}
                label={translation}
                type="radio"
                className={styles.feedbackRadioLabel}
              />
            ))}
          </div>
          <br />
          <Button
            type="submit"
            size="small"
            variant="secondary"
            disabled={pristine}
            translation={TXTCLI_Submit}
            className={styles.button}
          />
        </>
      )}
    />
  );
};
export default NegativeFeedback;
